export const DEFAULT_COUNTRY = 'NL'
export const CORE_COUNTRIES = ['NL', 'BE', 'DE', 'AT']
export const MARKETING_CORE_COUNTRIES = ['NL', 'BE', 'DE', 'AT']
export const PLUS_COUNTRIES = ['at', 'be', 'de', 'nl']
export const COUNTRIES_OC_HAS_VAT_ENTITY = [
    'NL',
    'FR',
    'DE',
    'BE',
    'AT',
    'DK',
    'GB',
    'CH',
]

/**
 * Returns all the country codes of the EU
 *
 * @returns {Array}
 */
export const euCountries = [
    'at',
    'be',
    'bg',
    'cy',
    'cz',
    'dk',
    'de',
    'ee',
    'es',
    'fi',
    'fr',
    'mc',
    'gr',
    'hu',
    'hr',
    'ie',
    'it',
    'lv',
    'lt',
    'lu',
    'mt',
    'nl',
    'pl',
    'pt',
    'ro',
    'se',
    'si',
    'sk',
]
